/**
 * 自定義編輯器垃圾桶樣式和交互
 */
const Blockly = window.Blockly;
(function() {
  //強制加載新的xml檔到工作空間後清空垃圾桶、撤銷棧
  const domToWorkspace = Blockly.Xml.domToWorkspace;
  Blockly.Xml.hardDomToWorkspace = function(xml, workspace){
    workspace.clear();
    domToWorkspace.bind(this)(xml, workspace);
    setTimeout(() => {
      if(workspace.trashcan){
        workspace.trashcan.contents_ = [];
        workspace.trashcan.hasBlocks_ = false;
      }
      workspace.clearUndo();
    });
  }
  Blockly.Trashcan.prototype.createDom = function() {
    this.svgGroup_ = Blockly.utils.createSvgElement(
      "g",
      {
        class: "blocklyTrash",
        fill: "#a8a8ac"
      },
      null
    );

    Blockly.utils.createSvgElement(
      "circle",
      {
        cx: 30,
        cy: 30,
        r: 30,
        fill: "#333333"
      },
      this.svgGroup_
    );
    var icon = Blockly.utils.createSvgElement(
      "g",
      {
        transform: "translate(13 13),scale(1.4)"
      },
      this.svgGroup_
    );
    var cap = Blockly.utils.createSvgElement(
      "g",
      {
        class: "trashcan-cap"
      },
      icon
    );
    this.cap_ = cap;
    this.icon_ = icon;
    var cap_1 = Blockly.utils.createSvgElement(
      "g",
      {
        transform: "translate(1 2.62)"
      },
      cap
    );
    Blockly.utils.createSvgElement(
      "path",
      {
        d: "M21.192 2.265H1a1 1 0 0 1 0-2h20.192a1 1 0 0 1 0 2"
      },
      cap_1
    );
    Blockly.utils.createSvgElement(
      "path",
      {
        d: "M15.17 2H8.848a1 1 0 0 1 0-2h6.324a1 1 0 0 1 0 2"
      },
      cap
    );
    var body = Blockly.utils.createSvgElement(
      "g",
      {
        class: "trashcan-body"
      },
      icon
    );
    Blockly.utils.createSvgElement(
      "path",
      {
        d:
          "M18.358 24.62H5.534c-1.556 0-2.823-1.371-2.823-3.058V7.175a1 1 0 0 1 2 0v14.387c0 .574.377 1.059.823 1.059h12.824c.446 0 .823-.485.823-1.06V7.176a1 1 0 0 1 2 0v14.387c0 1.687-1.266 3.059-2.823 3.059"
      },
      body
    );
    Blockly.utils.createSvgElement(
      "path",
      {
        d:
          "M8.847 20.034a1 1 0 0 1-1-1V8.76a1 1 0 1 1 2 0v10.274a1 1 0 0 1-1 1M15.17 20.034a1 1 0 0 1-1-1V8.578a1 1 0 0 1 2 0v10.456a1 1 0 0 1-1 1"
      },
      body
    );
    Blockly.bindEventWithChecks_(this.svgGroup_, "mouseup", this, this.click);
    Blockly.bindEvent_(this.svgGroup_, "mouseover", this, this.mouseOver_);
    Blockly.bindEvent_(this.svgGroup_, "mouseout", this, this.mouseOut_);
    this.animateLid_();
    // console.log(this.cap_);
    this.cap_.setAttribute("transition", "all 700ms ease");
    return this.svgGroup_;
  };
  Blockly.Trashcan.prototype.animateLid_ = function () {
    if (this.isOpen) {
      this.icon_.setAttribute("fill", "#0ED3FF");
    } else {
      this.icon_.setAttribute("fill", "#A8A8AC");
    }
    this.lidOpen_ += this.isOpen ? 0.2 : -0.2;
    this.lidOpen_ = Math.min(Math.max(this.lidOpen_, this.minOpenness_), 1);
    this.setLidAngle_(this.lidOpen_ * -3);
    this.lidOpen_ > this.minOpenness_ &&
      1 > this.lidOpen_ &&
      (this.lidTask_ = setTimeout(this.animateLid_.bind(this), 20));
  };
  Blockly.Trashcan.prototype.setLidAngle_ = function (a) {
    this.isOpen === false
      ? this.cap_ &&
        this.cap_.setAttribute("transform", "translate(0, " + a + ")")
      : this.cap_ &&
        this.cap_.setAttribute(
          "transform",
          "translate(" +
            a * -2 +
            ", " +
            a * 3 +
            ")" +
            " rotate(" +
            a * -10 +
            ")"
        );
  };
  Blockly.Trashcan.prototype.onDelete_ = function() {
    var a = this;
    return function (b) {
      0 >= a.workspace_.options.maxTrashcanContents ||
        b.type != Blockly.Events.BLOCK_DELETE ||
        ((b = a.cleanBlockXML_(b.oldXml)),
        -1 == a.contents_.indexOf(b) &&
          (a.contents_.unshift(b),
          a.contents_.length > a.workspace_.options.maxTrashcanContents &&
            a.contents_.splice(
              a.workspace_.options.maxTrashcanContents,
              a.contents_.length - a.workspace_.options.maxTrashcanContents
            ),
          (a.hasBlocks_ = !0),
          (a.minOpenness_ = a.HAS_BLOCKS_LID_ANGLE),
            a.setLidAngle_(0 * a.minOpenness_)
          ));
    };
  };
})();
